import React from 'react';

import { StartEnjoyingButtonStyles } from './StartEnjoyingButton.styles';

interface StartEnjoyingButtonProps {
  onClick?: () => void;
}

export const StartEnjoyingButton: React.FC<StartEnjoyingButtonProps> = ({
  onClick,
}) => {
  return (
    <StartEnjoyingButtonStyles onClick={onClick}>
      Start enjoying
    </StartEnjoyingButtonStyles>
  );
};
